import React, { useMemo } from 'react';
import DOMPurify from 'dompurify';
import parse from 'html-react-parser';
import { Box } from '@mui/material';

const getBodyHtml = (html = '') => {
	const doc = new DOMParser().parseFromString(html, 'text/html');
	return doc.body?.innerHTML || html;
};

const SafeHtmlContent = ({ html = '' }) => {
	const cleanHtml = useMemo(() => {
		const bodyHtml = getBodyHtml(html);

		return DOMPurify.sanitize(bodyHtml, {
			FORBID_TAGS: ['script', 'iframe', 'object', 'embed', 'form'],
			FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover', 'onfocus', 'onblur'],
		});
	}, [html]);

	return (
		<Box
			sx={{
				position: 'relative',
				overflow: 'auto',
				maxWidth: '100%',
				isolation: 'isolate',
				contain: 'layout paint style',

				'& *': {
					maxWidth: '100%',
					boxSizing: 'border-box',
				},

				'& [style*="position: absolute"], & [style*="position:absolute"], & [style*="position: fixed"], & [style*="position:fixed"]':
					{
						position: 'static !important',
					},

				'& [style*="z-index"]': {
					zIndex: 'auto !important',
				},

				'& table': {
					maxWidth: '100%',
					overflowX: 'auto',
				},

				'& td, & th': {
					wordBreak: 'break-word',
				},

				'& img': {
					maxWidth: '100%',
					height: 'auto',
				},
			}}
		>
			{parse(cleanHtml)}
		</Box>
	);
};

export default SafeHtmlContent;
